import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import "./Timeslots.css";
import Swal from "sweetalert2";

const monthNames = [
  "január", "február", "március", "április", "május", "június",
  "július", "augusztus", "szeptember", "október", "november", "december"
];

const Timeslots = () => {
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const [availableSlots, setAvailableSlots] = useState({});
  const [deleteMode, setDeleteMode] = useState(false);
  const navigate = useNavigate();

  const fetchSlots = () => {
    fetch("/api/time-slots/?t=" + new Date().getTime())
      .then((res) => res.json())
      .then((data) => {
        const slots = data.time_slots ? data.time_slots : (Array.isArray(data) ? data : []);

        const grouped = {};
        slots.forEach((s) => {
          if (!s.is_booked) {
            const parts = s.date.split("-"); // "YYYY-MM-DD"
            const mNum = parseInt(parts[1], 10);
            const dNum = parseInt(parts[2], 10);
            if (!grouped[mNum]) grouped[mNum] = {};
            if (!grouped[mNum][dNum]) {
              // JAVÍTÁS: a teljes eredeti dátumot is eltároljuk,
              // nem csak a hónap/nap számot -> törléskor ezt használjuk,
              // nem kell kitalálni az évet.
              grouped[mNum][dNum] = { date: s.date, times: [] };
            }

            const timeStr = s.time.substring(0, 5); // "HH:MM"
            if (!grouped[mNum][dNum].times.includes(timeStr)) {
              grouped[mNum][dNum].times.push(timeStr);
            }
          }
        });
        setAvailableSlots(grouped);
      })
      .catch((err) => console.error("Hiba:", err));
  };

  useEffect(() => { fetchSlots(); }, []);

  const exportToExcel = () => {
    let data = [];
    Object.keys(availableSlots).forEach((m) => {
      Object.keys(availableSlots[m]).forEach((d) => {
        availableSlots[m][d].times.forEach((t) => {
          data.push({ "Hónap": monthNames[m - 1], "Nap": `${d}.`, "Időpont": t });
        });
      });
    });
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Időpontok");
    XLSX.writeFile(wb, "szabad_idopontok.xlsx");
  };

  const handleDelete = (day, time, fullDate) => {
    const token = localStorage.getItem("authToken");

    Swal.fire({
      title: "Biztosan törölni szeretnéd?",
      text: `${fullDate} ${time} időpont törlése.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Igen, törlöm!",
      cancelButtonText: "Mégse",
    }).then((result) => {
      if (!result.isConfirmed) return;

      fetch("/api/delete-time-slot/", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Authorization": `Token ${token}` },
        // JAVÍTÁS: a ténylegesen tárolt dátumot küldjük, nem egy kitalált évet.
        // JAVÍTÁS: a backend "HH:MM:SS" formátumot vár, vissza kell tenni a ":00"-t.
        body: JSON.stringify({ date: fullDate, time: time + ":00" })
      })
        .then((res) => {
          if (!res.ok) throw new Error("delete failed");
          return res.json();
        })
        .then(() => {
          Swal.fire("Törölve!", "Az időpont sikeresen törölve lett.", "success");
          fetchSlots();
        })
        .catch(() => {
          Swal.fire("Hiba", "Nem sikerült törölni az időpontot!", "error");
        });
    });
  };

  return (
    <div className="timeslots-page">
      <div className="button-container">
        <button className="export-button" onClick={exportToExcel}>📥 Excel export</button>
        <button className="delete-button" onClick={() => setDeleteMode(!deleteMode)}>
          {deleteMode ? "❌ Kész" : "🗑️ Törlés mód"}
        </button>
        <button className="back-button" onClick={() => navigate("/admin")}>⬅️ Vissza</button>
      </div>
      <div className="timeslots-container">
        <h1 className="timeslots-title">Szabad időpontok</h1>
        <select className="timeslots-select" value={selectedMonth} onChange={(e) => setSelectedMonth(parseInt(e.target.value))}>
          {monthNames.map((n, i) => <option key={i} value={i + 1}>{n}</option>)}
        </select>
        <div className="timeslot-list">
          {availableSlots[selectedMonth] && Object.keys(availableSlots[selectedMonth]).length > 0 ? (
            Object.keys(availableSlots[selectedMonth]).sort((a, b) => a - b).map((day) => {
              const dayData = availableSlots[selectedMonth][day];
              return (
                <div key={day} style={{ marginBottom: "20px" }}>
                  <h3 className="timeslot-day">{day}. nap</h3>
                  <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "10px" }}>
                    {dayData.times.sort().map((t, i) => (
                      <span
                        key={i}
                        className={`timeslot-time ${deleteMode ? "deletable" : ""}`}
                        onClick={() => deleteMode && handleDelete(day, t, dayData.date)}
                      >
                        {t}
                      </span>
                    ))}
                  </div>
                </div>
              );
            })
          ) : (
            <p className="timeslot-day">Nincsenek szabad időpontok ebben a hónapban.</p>
          )}
        </div>
      </div>
    </div>
  );
};
export default Timeslots;
         
